<template>
  <div class="box">
    <div class="header-bar">
      <div class="header-content">
        <van-icon name="orders-o" size="48" color="#FFF" />
        <div class="header-title">批次列表</div>
        <div class="header-count" v-if="batchList.length > 0">{{ batchList.length }}项</div>
      </div>
    </div>
    <div class="list-container">
      <van-empty v-if="batchList.length === 0" description="暂无批次数据" />
      <div v-else class="batch-list">
        <div class="batch-item" v-for="(item, index) in batchList" :key="index" @click="handleClick(item)">
          <div class="item-header">
            <div class="item-number">{{ item.batchName }}</div>
            <div class="item-status-badge" :class="getStatusClass(item.batchState)">
              {{ getStatusText(item.batchState) }}
            </div>
          </div>
          <div class="item-content">
            <div class="item-info-row">
              <van-icon name="label-o" size="32" color="#999" />
              <div class="info-text">
                <span class="info-label">批次分类</span>
                <span class="info-value">{{ item.batchCategory || '未知分类' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBatch } from '@/service/insurance'
export default {
  props: {},
  data() {
    return {
      batchList: []
    }
  },
  mounted() {
    this.getBatchList()
  },
  methods: {
    handleClick(item) {
      this.$router.push({
        path: '/batch/detail',
        query: {
          id: item.batchId
        }
      })
    },
    getBatchList() {
      getBatch()
        .then((res) => {
          console.log(res)
          this.batchList.push(res.data)
        })
        .catch((err) => {
          console.error('获取批次列表失败:', err)
          this.$toast.fail('获取批次列表失败')
        })
    },
    getStatusText(status) {
      const statusMap = {
        0: '未开始',
        1: '进行中',
        2: '已结束'
      }
      return statusMap[status] || '未知'
    },
    getStatusClass(status) {
      const classMap = {
        0: 'status-pending',
        1: 'status-active',
        2: 'status-ended'
      }
      return classMap[status] || ''
    },
    handleGoBack() {
      this.$router.replace('/')
    }
  }
}
</script>

<style lang="stylus" scoped>
.box{
  position relative
  min-height 100vh
  background linear-gradient(180deg, #f8f9fa 0%, #f5f5f5 100%)

  .header-bar{
    background linear-gradient(135deg, #E99D42 0%, #ffb366 100%)
    padding 40px 30px 50px 30px
    box-shadow 0 4px 20px rgba(233, 157, 66, 0.2)

    .header-content{
      display flex
      align-items center
      flex-direction column

      .header-title{
        color #fff
        font-size 40px
        font-weight bold
        margin-top 20px
        text-shadow 0 2px 4px rgba(0, 0, 0, 0.1)
      }

      .header-count{
        background rgba(255, 255, 255, 0.3)
        color #fff
        padding 8px 24px
        border-radius 20px
        font-size 24px
        margin-top 16px
        font-weight 500
        backdrop-filter blur(10px)
      }
    }
  }

  .list-container{
    padding 30px
    padding-bottom 80px

    .batch-list{
      .batch-item{
        background #fff
        border-radius 20px
        margin-bottom 24px
        box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
        overflow hidden
        transition all 0.3s cubic-bezier(0.4, 0, 0.2, 1)
        border 2px solid transparent

        &:active{
          transform translateY(2px)
          box-shadow 0 2px 10px rgba(0, 0, 0, 0.12)
        }

        &:hover{
          border-color rgba(233, 157, 66, 0.3)
          box-shadow 0 8px 30px rgba(233, 157, 66, 0.15)
        }

        .item-header{
          background linear-gradient(135deg, rgba(233, 157, 66, 0.05) 0%, rgba(255, 179, 102, 0.05) 100%)
          padding 24px 30px
          display flex
          justify-content space-between
          align-items center
          border-bottom 1px solid #f0f0f0

          .item-number{
            font-size 28px
            font-weight bold
            color #E99D42
          }

          .item-status-badge{
            padding 8px 20px
            border-radius 20px
            font-size 24px
            font-weight 600
            letter-spacing 1px

            &.status-pending{
              background linear-gradient(135deg, #fff7e6 0%, #fff4d9 100%)
              color #fa8c16
              border 1px solid #ffecc7
            }

            &.status-active{
              background linear-gradient(135deg, #f6ffed 0%, #d4f3d1 100%)
              color #52c41a
              border 1px solid #b7eb8f
            }

            &.status-ended{
              background #f5f5f5
              color #8c8c8c
              border 1px solid #d9d9d9
            }
          }
        }

        .item-content{
          padding 30px

          .item-info-row{
            display flex
            align-items center

            .info-text{
              flex 1
              margin-left 16px
              display flex
              flex-direction column

              .info-label{
                font-size 24px
                color #999
                margin-bottom 8px
              }

              .info-value{
                font-size 32px
                color #333
                font-weight 600
              }
            }
          }
        }
      }
    }
  }

  .confirm{
    position fixed
    bottom 20px
    left 50%
    transform translateX(-50%)
    width 100%
    max-width 750px
    padding 0 30px

    .confirm-btn{
      border-radius 50px
      width 100%
      height 88px
      font-size 32px
      font-weight bold
      box-shadow 0 8px 20px rgba(233, 157, 66, 0.3)

      &:active{
        box-shadow 0 4px 10px rgba(233, 157, 66, 0.3)
      }
    }
  }
}
</style>
